<template>
    
  <div class="Typeahead">
    
     <div class="input-group">
      <span class="input-group-addon">
        <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
      </span>
      <input type="text"
             id="caller-typeahead"
             class="form-control"
             placeholder="Firma suchen..."
             autocomplete="off"
             v-model="query"
             @keydown.down="down"
             @keydown.up="up"
             @keydown.enter="hit"
             @kedown.tab="hit"
             @keydown.esc="reset"
             @blur="hit"
             @input="update"/>
      
    </div>
    

    <ul v-show="hasItems">
      <li v-for="(item, index) in items" :class="activeClass(index)" @mousedown="setActive(index)" >
        <span class="name" v-html="highlight(item.name)"></span>
        <span class="screen-name" v-html="highlight(item.city)"></span>
      </li>
    </ul>
  </div>
</template>



<script>

import VueTypeahead from './common/typeahead.common'
import bus from './common/bus'



export default {
  extends: VueTypeahead,

  data () {
    return {
      takeFirstItemOnHit: false,
      limit: 10,
      minChars: 1,
      idCompanyClient: 0,
    }
  },
  created: function () {
    bus.registerOnIdCompanyClient(this.onIdCompanyClient);
    this.idCompanyClient = bus.call.idCompanyClient;
  },
  computed: {
    src: function () {
      return bus.config.path + '/search/companycaller/' + this.idCompanyClient
    }
  },
  methods: {
    setActiveAndHit (index ) {
      this.setActive(index)
      //this.hit()
    },

    onHit (item ) {
      //bus.call.idCompanyCaller = item.name;
      bus.emitCompanyCaller(item);
      this.reset();
    },
    
    onHitNew (query) {
      // Ist es nicht besser über den internen bus zu gehen
      // this.$parent.$emit('onNewCompanyCaller',this.kombox.id);

      bus.emitNewCompanyCaller(query);
      this.reset();
    },
    
    highlight: function(value){
        var query = this.query.substring(0,1) == '%' ? this.query.substring(1) : this.query;
        return value.replace( RegExp("("+query+")","gi"), '<b>$1</b>' );
    },

    onIdCompanyClient: function(idCompanyClient){
      this.idCompanyClient = idCompanyClient;
    }
    
  }
  
}
</script>



<style scoped>
.Typeahead {
  position: relative;
}

.Typeahead__input {
  width: 100%;
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.42857143;
  box-shadow: inset 0 1px 4px rgba(0,0,0,.4);
  -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  font-weight: 300;
  padding: 12px 26px;
  border: none;
  border-radius: 22px;
  letter-spacing: 1px;
  box-sizing: border-box;
}

.Typeahead__input:focus {
  border-color: #4fc08d;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px #4fc08d;
}

.fa-times {
  cursor: pointer;
}

i {
  float: right;
  position: relative;
  top: 30px;
  right: 29px;
  opacity: 0.4;
}

ul {
  position: absolute;
  padding: 0;
  margin-top: 8px;
  min-width: 100%;
  background-color: rgb(255, 254, 234);
  list-style: none;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0,0,0, 0.25);
  z-index: 1000;
}

li {
  padding: 10px 16px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

li:first-child {
  border-radius: 4px 4px 0 0;
}

li:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 0;
}

li span{
  color: #2c3e50;
}

.active {
  background-color: #3aa373;
}

.active span {
  color: white;
}

.name {
  font-weight: 400;
  font-size: 18px;
}

.screen-name {
  font-style: italic;
}

.screen-info {
  font-style: italic;
  color: red;
}
  
  
</style>



// WEBPACK FOOTER //
// CompanyCallerTypeahead.vue?bd15ffd6